import HeaderPasos from "../../../componentsUI/estructura/headerPasos/headerPasos.js";

import FacturasGrid from "../contenedorContexto/facturasGrid.js";
import ListaFacturasConfirmadas from "../listaVentasConfirmadas/facturasConfirmadasLista.js";
import ListaFacturasCanceladas from "../listaVentasCanceladas/facturasCanceladaLista.js";
import TablaVentasXMetodo from "../templateTotales/totalesmetodopago/tablaVentasXMetodo.js";

//import ListaPagosConfirmadosDrive from "../listaTransacciones/listaPagosConfirmadosDrive.js";
//import ListaPagosCanceladosDrive from "../listaTransacciones/listaPagosCanceladosDrive..js";

const pasosPagos = [
  {
    id: "pendientes",
    label: "Pagos pendientes",
    component: <FacturasGrid />,
  },
  {
    id: "confirmados",
    label: "Pagos confirmados",
    component: <ListaFacturasConfirmadas />,
  },
  {
    id: "cancelados",
    label: "Pagos cancelados",
    component: <ListaFacturasCanceladas />,
  },
    {
    id: "totales",
    label: "Pagos Totales" ,
    component: <TablaVentasXMetodo />,
  },
];

export default function TemplatePagos() {
  return (
    <HeaderPasos
      titulo="Gestión de Pagos"
      pasos={pasosPagos}
    />
  );
}
